import i18n from 'src/i18n';
import ConfigInfo from 'src/views/Pages/Dashboard/Sigatoka/Config/ConfigInfo.vue';
import BwLeafFormatter from 'src/views/Pages/Dashboard/Sigatoka/Config/BwLeafFormatter.vue';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'sigatoka_config_ages',
      label: i18n.t('sigatoka.ages_to_evaluate'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: ConfigInfo,
    },
    {
      prop: 'young_plant',
      label: `${i18n.t('sigatoka.evaluate_young_plants')}?`,
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: (row) => {
        return row.young_plant == 1
          ? i18n.t('common_words.yes')
          : i18n.t('common_words.no');
      },
    },
    {
      prop: 'config_bio_warning',
      label: `${i18n.t('sigatoka.can_config_bw')}?`,
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: (row) => {
        return row.config_bio_warning == 1
          ? i18n.t('common_words.yes')
          : i18n.t('common_words.no');
      },
    },
    {
      prop: 'sigatoka_config_leaves',
      label: i18n.t('sigatoka.number_leaves_to_evaluate'),
      minWidth: 150,
      sortable: true,
      show: false,
      formatter: (row) => {
        return row.sigatoka_config_leaves.map((item) => item.leaf).join(', ');
      },
    },
    {
      prop: 'sigatoka_config_bws',
      label: i18n.t('sigatoka.bw_config'),
      minWidth: 150,
      sortable: true,
      show: false,
      formatter: BwLeafFormatter,
    },
  ];

  return { tableColumns };
};
export default configTable;
